module.exports = __webpack_public_path__ + "img/terrassen-opt.f8273712.jpg";